"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable*/
exports.default = {
  "login": {
    "onlineTraining": "Platform Pelatihan Online Liaogao e Academy",
    "captchaNotEmpty": "kode verifikasi harus diisi",
    "accountNotEmpty": "Akun tidak boleh kosong",
    "passwordBits": "Panjang kata sandi tidak boleh kurang dari 6 digit",
    "incorrectTips": "Nama pengguna atau kata sandi salah dimasukkan",
    "sign": "Gabung",
    "passwordNotEmpty": "kata sandi tidak boleh kosong",
    "passwordBitsLong": "Panjang kata sandi tidak boleh lebih dari 18 digit",
    "captchaTips": "kode verifikasi salah",
    "confirmNot": "Kata sandi yang dimasukkan tidak sesuai dengan kata sandi yang dikonfirmasi",
    "inputAccount": "Silakan masukkan Nama Pengguna",
    "inputPassword": "Silakan masukkan kata sandi",
    "inputCaptcha": "harap masukkan kode verifikasi",
    "forgetPassword": "lupa Password",
    "nextStep": "Langkah berikutnya",
    "inputUserName": "harap masukkan nama pengguna",
    "phoneNumber": "nomor telepon",
    "phoneEmpty": "Nomor telepon tidak boleh kosong",
    "surePasswordEmpty": "konfirmasi kata sandi tidak boleh kosong",
    "userNameEmpty": "Nama pengguna tidak boleh kosong",
    "getCaptcha": "dapatkan kode verifikasi",
    "msgCaptcha": "Kode verifikasi SMS",
    "prevStep": "Sebelumnya",
    "surePassword": "Mohon konfirmasi kata sandi Anda",
    "reset": "Setel ulang",
    "resetSuccess": "Berhasil disetel ulang",
    "resetSuccessTips": "Anda telah berhasil mengatur ulang kata sandi Anda, silakan masuk ke login",
    "loginNow": "Masuk sekarang",
    "copyRight": "Hak Cipta dimiliki oleh ×%%%%%%, Hak Cipta @ 2020 京 ICP 备案",
    "loginFail": "Login gagal, silakan coba lagi!",
    "captchaFail": "Verifikasi kode verifikasi gagal",
    "failTips": "Verifikasi gagal",
    "inputOrigPassword": "Silakan masukkan kata sandi asli",
    "inputNewPassowrd": "Silakan masukkan kata sandi baru",
    "confimPassword": "Mohon konfirmasi kata sandi Anda",
    "sure": "menentukan",
    "cancel": "membatalkan",
    "changePasswordSuccess": "kata sandi telah diperbarui",
    "continueLogin": "daftar ulang",
    "resetLoginTips": "Anda telah berhasil mengubah kata sandi Anda, Anda harus masuk lagi, dan keluar secara otomatis setelah 3 detik",
    "passwordFormat": "Panjang kata sandi adalah 8 sampai 32 digit, termasuk angka dan huruf besar dan kecil",
    "changePassword": "ganti kata sandi",
    "poor": "lemah",
    "middle": "di",
    "strong": "Kuat",
    "logout": "Keluar dengan sukses",
    "formerPhone": "Nomor telepon asli",
    "newPhone": "Nomor telepon baru",
    "changePhoneSuccess": "Nomor ponsel berhasil diubah",
    "changePhoneSuccessTips": "Anda telah berhasil mengubah nomor telepon Anda",
    "goHome": "Buka beranda",
    "changePhone": "Ubah nomor ponsel",
    "newPhoneEmpty": "Nomor telepon baru tidak boleh kosong",
    "newPhoneFomat": "Format nomor telepon baru salah",
    "newPhoneSupport": "Nomor telepon baru tidak boleh sama dengan nomor telepon asli",
    "newPhoneBinded": "Nomor telepon baru telah terikat",
    "orgPhoneEmpty": "Nomor telepon asli tidak boleh kosong",
    "orgPhoneFormat": "Format nomor telepon asli salah",
    "orgPhoneNot": "Nomor telepon asli salah",
    "resetPassword": "setel ulang Kata Sandi",
    "phoneCaptchaEmpty": "Kode verifikasi telepon tidak boleh kosong",
    "accountVerif": "Verifikasi akun",
    "phoneVerif": "Verifikasi telepon",
    "resetDone": "Setel ulang selesai",
    "phoneFormat": "Format nomor telepon salah",
    "phoneBinded": "Nomor ponsel telah terikat",
    "loginVertif": "Otentikasi login",
    "clickGoHome": "Klik untuk kembali ke halaman login",
    "bingPhoneSuccess": "Berhasil mengikat nomor ponsel",
    "rightMessageChange": "Anda dapat mengeditnya di informasi pribadi di sisi kanan bilah navigasi",
    "bingPhone": "Ikat nomor ponsel"
  },
  "index": {
    "setAsHomePage": "Setup sebagai halaman depan",
    "addCollection": "Tambahkan ke Favorit",
    "telephone": "mendukung hotline",
    "Help": "Pusat Bantuan",
    "SystemMessage": "Pengingat sistem",
    "message": "berita",
    "emptyMessage": "Kosong",
    "checkAllMessage": "Lihat semua",
    "noMessage": "Tidak ada data",
    "fullScreen": "Tampilan layar penuh",
    "ExitSystem": "Keluar dari sistem ini",
    "back": "kembali",
    "top": "puncak",
    "backToTop": "Kembali ke atas",
    "homePage": "Rumah",
    "course": "Pembelajaran kursus",
    "onlineCourse": "Kelas Khusus Online",
    "faceCourse": "Pelatihan tatap muka",
    "examPractice": "Latihan ujian",
    "dataDownLoad": "Unduh",
    "userInfo": "Pusat pribadi",
    "Administration": "Latar belakang manajemen",
    "courseCategory": "jenis kursus",
    "examIsOver": "Penilaian selesai",
    "onlineHours": "Jam online",
    "faceHours": "Jam kelas tatap muka",
    "notice": "pengumuman",
    "checkAllNotice": "Lihat semua",
    "backToTopButton": "Kembali ke atas",
    "recommendCourse": "Kursus yang direkomendasikan",
    "impotentCourse": "Kursus kunci",
    "newCourse": "Kursus terbaru",
    "hotCourse": "Kursus Terpanas",
    "requiredCourses": "Mata kuliah wajib",
    "electiveCourses": "Mata kuliah pilihan",
    "startStudy": "mulai belajar",
    "continueStudy": "Lanjutkan belajar",
    "coursesRanking": "Peringkat Seleksi Kursus",
    "studentRanking": "Peringkat siswa",
    "currentUser": "Pengguna saat ini",
    "userHead": "gambar profil",
    "currentHead": "Avatar saat ini",
    "change": "memodifikasi",
    "accountPassword": "kata sandi akun",
    "encryPhone": "Telepon rahasia",
    "currentPhone": "Telepon saat ini",
    "userName": "nama pengguna",
    "head": "Avatar",
    "coverImage": "gambar sampul",
    "uploadError": "gagal mengunggah",
    "autoSetHomeTips": "Browser Anda tidak mendukung pengaturan halaman beranda otomatis, gunakan menu browser untuk mengaturnya secara manual!",
    "operateConfig": "Operasi ini ditolak oleh browser. Jika Anda ingin mengaktifkan fungsi ini, masukkan about: config di bilah alamat, lalu setel nilai signed.applets.codebase_principal_support menjadi true",
    "favoriteTips": "Karena keterbatasan fungsi browser 360, silakan tekan Ctrl + D untuk menandai secara manual!",
    "autoFavorite": "Browser Anda tidak mendukungnya, tekan Ctrl + D untuk menandai secara manual!",
    "required": "Item ini wajib diisi",
    "to": "untuk",
    "trainingTime": "masa pelatihan",
    "coursehours": "Jam kelas",
    "human": "orang-orang",
    "wecome": "Selamat datang!",
    "allCourses": "Semua kursus"
  },
  "course": {
    "coursesCategory": "jenis kursus",
    "allCourses": "Semua kursus",
    "electiveCourses": "Mata kuliah pilihan",
    "requiredCourses": "Kursus wajib",
    "collect": "Favorit",
    "cancelCollect": "Tidak disukai",
    "searchTips": "Harap masukkan nama kursus",
    "startStudy": "mulai belajar",
    "continueStudy": "Lanjutkan belajar",
    "cancelConfirm": "Tidak disukai",
    "cancelTips": "Konfirmasikan untuk membatalkan permintaan",
    "confirmButton": "Tombol batal",
    "count": "Total",
    "item": "Artikel",
    "up": "Halaman sebelumnya",
    "next": "Halaman selanjutnya",
    "items": "Artikel / Halaman",
    "go": "Langsung ke",
    "page": "halaman",
    "man": "orang-orang",
    "score": "Menit",
    "courseYear": "tahun",
    "courseTeachers": "guru",
    "noDesc": "Tidak ada perkenalan",
    "teachersDesc": "Profil guru",
    "checkLog": "Lihat catatan",
    "reExam": "Tes ulang",
    "examLog": "Catatan Ujian",
    "viewPaper": "Lihat kertas tes",
    "noPublicExam": "Makalah ujian tidak akan diumumkan",
    "marking": "Menandai",
    "closeButton": "mematikan",
    "examResultPage": "Halaman hasil ujian",
    "examPage": "Halaman ujian",
    "startExam": "Mulai ujian",
    "coursehours": "Jam kelas",
    "courseInfo": "Rincian kursus",
    "courseChapter": "Bab kursus",
    "courseNote": "Catatan kursus",
    "courseData": "Informasi Kursus",
    "courseExamination": "Ujian",
    "evaluate": "Evaluasi",
    "courseEvaluate": "Evaluasi kursus",
    "no": "Pertama",
    "chapter": "bab",
    "isEvaluate": "Dievaluasi",
    "uploadDate": "Waktu unggah",
    "className": "Nama kelas",
    "resourceSize": "Ukuran sumber daya",
    "times": "Waktu",
    "typeViedo": "video",
    "typeImage": "gambar",
    "typeDoc": "Dokumentasi",
    "typeOuth": "lain",
    "typeImages": "Banyak gambar",
    "newComment": "up to date",
    "hotComment": "Terpanas",
    "openComment": "Saya ingin berkomentar",
    "cancelButton": "membatalkan",
    "publishButton": "melepaskan",
    "commentTips": "Harap masukkan konten komentar",
    "emptyCommentTips": "Konten komentar tidak boleh kosong",
    "noteSource": "Dari",
    "deleteNoteButton": "menghapus",
    "needIETips": "Courseware saat ini membutuhkan browser IE!",
    "donwNum": "waktu unduh",
    "preview": "Pratinjau",
    "relatedCourses": "Kursus terkait",
    "studentsNum": "Jumlah kursus",
    "courseHours": "Jam kursus",
    "JoinLearning": "Bergabunglah dengan pembelajaran"
  },
  "onlineclass": {
    "allTheClass": "Semua kelas",
    "beginClass": "Kelas dimulai",
    "notBeginClass": "Tidak ada kelas",
    "endClass": "Tutup",
    "searchThoseClass": "Cari kelas khusus online yang Anda minati",
    "startLearn": "Masuk ke kelas",
    "registrationTime": "waktu pendaftaran",
    "to": "untuk",
    "trainingTime": "masa pelatihan",
    "subjectsClass": "Kursus",
    "classStudy": "Studi kelas",
    "quantityOfCourses": "Jumlah kursus",
    "numberOfParticipants": "Jumlah pelamar",
    "registerNow": "Daftar sekarang",
    "resetRegister": "Batalkan namanya",
    "participating": "Telah berpartisipasi",
    "subjects": "pintu",
    "classExam": "Ujian kelas",
    "notParticipat": "Tidak terlibat",
    "startExim": "Mulai ujian",
    "handed": "melaksanakan tugas",
    "score": "Skor",
    "cacheSave": "Penyimpanan sementara",
    "subjectsNumber": "Jumlah pintu",
    "notice": "Memperhatikan",
    "communication": "komunikasi",
    "detail": "Detail",
    "courses": "tentu saja",
    "allClass": "Semua",
    "compulsory": "Wajib",
    "elective": "Pilihan",
    "Learned": "Terpelajar",
    "classPassIndicator": "Indikator kelulusan kelas",
    "excellence": "luar biasa",
    "compulsoryNumber": "Jumlah lintasan yang diperlukan",
    "electiveNumber": "Jumlah pilihan lulus",
    "compulsoryStandard": "Jam standar wajib",
    "electiveStandard": "Jam pilihan",
    "examIsPass": "Apakah ujiannya lulus",
    "resource": "Sumber daya",
    "source": "data",
    "new": "up to date",
    "hot": "Terpanas",
    "updateTime": "Waktu unggah",
    "downloadCount": "Download",
    "download": "unduh",
    "resourceSize": "Ukuran sumber daya",
    "resourceType": "Jenis dari",
    "allType": "Semua jenis",
    "videos": "video",
    "images": "gambar",
    "document": "Dokumentasi",
    "others": "lain",
    "multiImages": "Banyak gambar",
    "inforCertificate": "sertifikat",
    "notSubmit": "dibatalkan pengirimannya",
    "submitHomework": "menyerahkan pekerjaan rumah",
    "submitTime": "Waktu pengiriman",
    "uploadHomework": "Unggah tugas",
    "clickHere": "klik disini",
    "upload": "Unggah",
    "formatSupport": "Dukungan format file",
    "submited": "diserahkan",
    "notApproved": "Belum ditinjau",
    "approved": "ujian lulus",
    "downloadHomework": "Unduh tugas",
    "reSubmit": "Kirim ulang",
    "myScore": "Nilai saya",
    "comments": "Komentar",
    "talk": "Bahas",
    "category": "klasifikasi",
    "classTalk": "Diskusi kelas",
    "groupTalk": "Kelompok diskusi",
    "wantTalk": "Saya ingin berdiskusi",
    "publish": "melepaskan",
    "undo": "membatalkan",
    "delete": "menghapus",
    "iknow": "Saya mendapatkannya",
    "faceCourseClass": "Pelatihan tatap muka",
    "onlineClasses": "Kelas Khusus Online",
    "openReservation": "Terbuka untuk pendaftaran",
    "talkTech": "penceramah",
    "address": "lokasi",
    "up": "di",
    "noon": "Tengah hari",
    "down": "dibawah",
    "even": "terlambat",
    "classOvered": "Kelas berakhir",
    "nopassed": "Belum terdaftar",
    "inputTalkContent": "Silakan masukkan konten diskusi",
    "groupMan": "Pemimpin grup",
    "showAllGroup": "Lihat semua anggota",
    "hideAllGroup": "Singkirkan semua anggota tim",
    "showAllMan": "Lihat semua siswa",
    "hideAllMan": "Singkirkan semua siswa",
    "reply": "Balasan",
    "isDelete": "Anda yakin ingin menghapus?",
    "cancelLike": "Tidak seperti",
    "classNotStar": "Pendaftaran kelas belum dimulai",
    "classIsEnd": "Pendaftaran kelas telah berakhir",
    "clickReset": "Klik tombol untuk menarik nama",
    "agentRegister": "Daftar lagi",
    "cancelRegister": "Batalkan pendaftaran",
    "reason": "Alasannya",
    "inputReason": "Harap masukkan alasan pencabutan",
    "homework": "operasi",
    "leaveMaxBits": "Alasan meminta cuti tidak boleh lebih dari 100 kata",
    "leaveNotEndTime": "Waktu mulai cuti tidak boleh sama dengan waktu berakhir",
    "sizeNot": "Ukuran tidak boleh melebihi",
    "close": "mematikan",
    "teacher": "guru",
    "noIntroduction": "Tidak ada perkenalan"
  },
  "offlineclass": {
    "fullTimeToFace": "Pengajaran tatap muka penuh waktu",
    "onlineToFace": "Pada pekerjaan",
    "allClass": "Semua kelas",
    "openClass": "Kelas terbuka",
    "searchThoseClass": "Telusuri kursus pelatihan tatap muka yang Anda minati",
    "startLearn": "Masuk ke pembelajaran",
    "classHours": "Jam kelas",
    "h": "Waktu",
    "firstWeek": "Minggu 1",
    "askLeave": "Saya ingin mengambil cuti",
    "monday": "Senin",
    "tuesday": "Selasa",
    "wednesday": "Rabu",
    "thursday": "Kamis",
    "fridays": "Jumat",
    "saturdays": "pada hari Sabtu",
    "sunday": "pada hari Minggu",
    "morning": "pagi",
    "afternoon": "saat sore hari",
    "evening": "di malam hari",
    "leaveType": "Jenis cuti",
    "selectLeaveType": "Pilih jenis cuti",
    "leaveTime": "Waktu istirahat",
    "selctLeaveTime": "Pilih waktu cuti",
    "reasonLeave": "Alasan cuti",
    "inputReasonLeave": "Harap masukkan alasan cuti",
    "sure": "menentukan",
    "selectTime": "periode seleksi",
    "casualLeave": "Cuti pribadi",
    "sickLeave": "cuti sakit",
    "seven": "hari",
    "one": "Satu",
    "two": "dua",
    "three": "tiga",
    "for": "empat",
    "five": "Fives",
    "six": "enam",
    "clear": "Kosong",
    "evaluating": "Evaluasi",
    "courseEvaluation": "Evaluasi pengajaran",
    "inputEvaluating": "Harap masukkan konten penilaian",
    "beDoing": "Sedang berlangsung",
    "notStarted": "belum dimulai",
    "evaluationInProgress": "Evaluasi sedang berlangsung",
    "notEvaluation": "Tidak dievaluasi",
    "evaluationStartTime": "Evaluasi waktu mulai",
    "startEvaluation": "Mulai evaluasi",
    "classEvaluation": "Penilaian kelas",
    "photoCategory": "Klasifikasi album",
    "learningActivity": "Kegiatan belajar",
    "addPhoto": "Foto baru yang ditambahkan",
    "photoMessage": "Informasi foto",
    "photoName": "Nama foto",
    "inputPhotoName": "Harap masukkan nama foto",
    "uploadPhoto": "Unggah foto",
    "formatSupport": "Dukungan format dukungan",
    "tickets": "Zhang",
    "group": "kelompok",
    "notGroup": "tidak diklasifikasikan",
    "groupTalk": "Kelompok diskusi",
    "teacherAbout": "Profil guru",
    "teacherTech": "Kursus yang diambil",
    "photos": "album Foto",
    "phontoRequier": "Foto harus diunggah",
    "addPhoneTips": "Berhasil ditambahkan, harap tunggu tinjauan",
    "sureDelete": "Anda yakin ingin menghapus",
    "deleteSuccess": "berhasil dihapus",
    "phoneNameReq": "Kolom nama foto harus diisi",
    "longNotBits": "Panjangnya tidak boleh lebih dari 50 karakter",
    "phoneIsOccur": "Nama foto sudah ada",
    "evaluateTime": "Waktu evaluasi",
    "evalueteNotStar": "Evaluasi belum dimulai",
    "evaluateEnds": "Evaluasi telah berakhir",
    "isEvaluated": "Dinilai",
    "at": "di",
    "submit": "Kirimkan",
    "seeEvalute": "Lihat penilaian",
    "inputIdea": "Silakan masukkan pemikiran Anda",
    "submitFailure": "Gagal menyerahkan",
    "seeRecord": "Lihat catatan",
    "examRecord": "Catatan Ujian",
    "seeSubmite": "Lihat kertas tes",
    "resultPage": "Halaman hasil ujian",
    "hoursStandard": "Tidak dapat mengikuti ujian jika jam pelajaran tidak sesuai standar",
    "examPage": "Halaman ujian",
    "questionnaire": "Daftar pertanyaan",
    " coursesTaught": "Kursus yang diajarkan",
    "passed": "oleh",
    "is": "Iya",
    "not": "tidak",
    "passedState": "Status lulus",
    "sketch": "minuman",
    "partySchool": "Kelas Pelatihan Sekolah Pesta",
    "searchPartySchool": "Telusuri kelas pelatihan sekolah pesta yang Anda minati"
  },
  "exam": {
    "answerWarning": "Pertanyaan ujian ini adalah pertanyaan tunggal yang tidak dapat diubah, harap berhati-hati sebelum pertanyaan berikutnya",
    "inputAnswerTips": "tolong masukan jawaban anda",
    "problemPoints": "Analisa masalah",
    "examination": "Daftar untuk ujian",
    "knowledgeCompetition": "Kontes pengetahuan",
    "practice": "Praktik otonom",
    "notRegister": "Tidak terdaftar",
    "reviewAudit": "sedang ditinjau",
    "auditNoPass": "Audit gagal",
    "participanted": "terdaftar",
    "participant": "Daftar",
    "examTime": "waktu ujian",
    "examHours": "durasi",
    "registration": "Berhasil mendaftar",
    "reRegistration": "Batalkan namanya",
    "wrongQuestion": "Bank soal yang salah",
    "noInvolvement": "Tidak terlibat",
    "involvement": "Berpartisipasi",
    "searchExamPractice": "Cari ujian dan latihan yang Anda minati",
    "practiced": "Dipraktekkan",
    "startPractice": "Mulailah berlatih",
    "toFavorite": "Tambahkan ke Favorit",
    "prevPrevious": "Pertanyaan sebelumnya",
    "nextPrevious": "pertanyaan selanjutnya",
    "submitAnswers": "Kirimkan jawaban",
    "rightAnswers": "jawaban yang benar",
    "yourAnswers": "Jawaban Anda",
    "questionsAnalysis": "Analisis pertanyaan",
    "noAnalysis": "Tidak ada resolusi",
    "accuracy": "Tarif yang benar",
    "continuePracticed": "Terus berlatih",
    "topics": "tema"
  },
  "source": {
    "allResource": "Semua sumber daya",
    "commonResource": "Sumber daya umum",
    "classResource": "Sumber daya kelas",
    "resourceCategory": "Klasifikasi sumber daya",
    "searchResource": "Telusuri sumber daya yang Anda minati",
    "resourceTalk": "Evaluasi sumber daya",
    "previewResource": "Pratinjau sumber daya",
    "helpPoint": "Manual bantuan",
    "isEvaluation": "Anda sudah mengevaluasi!",
    "selectEvaluation": "Anda belum memilih peringkat!",
    "evaluationSuccess": "Evaluasi yang berhasil",
    "topRelise": "Puncak",
    "className": "Nama kelas",
    "resourceEvaluation": "Peringkat sumber daya"
  },
  "usercenter": {
    "386": "File pembelajaran",
    "myCourse": "Kursus saya",
    "hours": "Waktu",
    "loginAccount": "Masuk akun",
    "htllo": "Halo",
    "welcomeMessage": "Semoga Anda bahagia setiap hari",
    "underway": "Anda sedang melakukan",
    "annualAssessment": "Penilaian tahunan",
    "searchTips": "Masukkan nama kursus yang dicari",
    "completed": "Jadi",
    "allCourses": "Semua kursus",
    "requiredCourses": "Kursus wajib",
    "electiveCourses": "Mata kuliah pilihan",
    "all": "Semua",
    "ongoing": "pengolahan",
    "learnTo": "Belajar untuk",
    "inExams": "Ikuti tesnya",
    "noExams": "Tidak ada ujian",
    "delete": "menghapus",
    "pleaseSelect": "tolong pilih",
    "searchOnlineTips": "Cari kelas khusus online yang Anda minati",
    "passedCourse": "lulus",
    "failedCourse": "Tidak lulus",
    "myOnlineCourse": "Kelas khusus online saya",
    "myFaceCourse": "Kelas pelatihan tatap muka saya",
    "searchFaceTips": "Cari kursus yang Anda minati",
    "myExams": "Ujian saya",
    "allExams": "Semua ujian",
    "makeUpExam": "Untuk dibuat-buat",
    "marking": "Menandai",
    "onExam": "Ujian sedang berlangsung",
    "passedExam": "Ujian lulus",
    "examHours": "Durasi tes",
    "examOver": "Ujian sudah selesai",
    "exam": "pemeriksaan",
    "examLog": "Catatan Ujian",
    "myScore": "Nilai saya",
    "surplusMakeUpExam": "Ujian riasan yang tersisa",
    "times": "Waktu",
    "searchExamTips": "Masukkan nama pencarian",
    "haveTime": "Waktu tersisa",
    "question": "pertanyaan",
    "eachQuestion": "Setiap pertanyaan",
    "score": "Menit",
    "examExplain": "Deskripsi ujian",
    "confirmHandExams": "Apakah akan mengkonfirmasi pengajuan",
    "autoSaveFailed": "Penyimpanan otomatis gagal",
    "autoSaveSuccess": "Penyimpanan otomatis",
    "handExamsSuccess": "Berhasil diserahkan",
    "yourScore": "Nilai Anda",
    "noPublicAnswers": "Jawaban tidak akan diumumkan untuk ujian ini",
    "noPublicResult": "Makalah tes tidak akan diumumkan",
    "reExam": "Tes ulang",
    "practice": "Olahraga",
    "hasCollected": "dikumpulkan",
    "emptyAnswer": "Isi pilihan atau jawaban tidak boleh kosong",
    "isCorrect": "Solusi positif",
    "myCollected": "koleksi saya",
    "courseCollected": "Koleksi Kursus",
    "examCollected": "Pertanyaan tes",
    "deleteCollected": "Hapus favorit",
    "myLeave": "Saya pergi",
    "allLeave": "Semua pergi",
    "needAudit": "Menunggu keputusan",
    "auditDate": "waktu aplikasi",
    "searchLeaveTips": "Telusuri cuti yang Anda minati",
    "checkInfo": "lihat detailnya",
    "cancelLeave": "Cabut cuti",
    "leaveInfo": "Tinggalkan detail",
    "leaveState": "Kondisi saat ini",
    "teamLeader": "Pemimpin grup",
    "committeeMembers": "Komite Inspeksi Disiplin Organisasi",
    "headmaster": "kepala sekolah",
    "schoolLeader": "Pimpinan sekolah",
    "student": "Trainee",
    "auditMessage": "Alasan persetujuan",
    "onBusiness": "Untuk bisnis",
    "personal": "Untuk keuntungan pribadi",
    "rejectReasons": "Alasan penolakan",
    "confirmCancel": "Konfirmasikan apakah akan mencabut cuti",
    "cancelButton": "Mencabut",
    "cancelTitle": "Konfirmasi pencabutan",
    "empty": "tidak",
    "wrongQuestionBank": "Bank soal saya yang salah",
    "searchWrongTips": "Telusuri pertanyaan salah yang Anda minati",
    "deleteWrongQuestion": "Hapus bank soal yang salah",
    "myQuestionnaire": "Kuesioner saya",
    "isCompleted": "lengkap",
    "isOver": "lebih",
    "searchQuestionnaireTips": "Masukkan nama kuesioner pencarian",
    "questionnaireDate": "Waktunya kuesioner",
    "startQuestionnaire": "Mulailah menjawab",
    "checkQuestionnaire": "Lihat kuesioner",
    "allTeacher": "Semua guru",
    "newTeacher": "Tambahkan guru",
    "searchTeacherTips": "Telusuri guru yang Anda minati",
    "checkTeacher": "Melihat",
    "editTeacher": "edit",
    "workingIn": "Bekerja di",
    "location": "Lokasi permanen",
    "confirmDelete": "Hapus konfirmasi",
    "confirmDeleteTips": "Konfirmasi hapus",
    "recommendTeacher": "Rekomendasi guru",
    "addTeachers": "Guru baru",
    "teacherInfo": "Informasi pribadi",
    "teacherName": "Nama guru",
    "workUnit": "Majikan",
    "contact": "detail kontak",
    "teacherNameTips": "Silakan masukkan nama guru",
    "teacherWorkUnitTips": "Harap masukkan perusahaan",
    "teacherContactTips": "Harap masukkan informasi kontak guru",
    "teacherLocationTips": "Harap masukkan lokasi permanen",
    "teacherDescTips": "Silakan masukkan profil guru",
    "teachingInfo": "Informasi pengajaran",
    "teachingExpertise": "Keahlian mengajar",
    "fitLevel": "Cocok untuk mengajar tingkat objek",
    "fitBusiness": "Cocok untuk lini bisnis",
    "ruleNumber": "Harap masukkan bilangan bulat dalam 8 digit (termasuk 8)",
    "rulePhone": "silahkan masukkan nomor telepon yang benar",
    "ruleString": "Harap masukkan 80 karakter (termasuk 80)",
    "ruleIsNumber": "Silakan masukkan nomornya",
    "pause": "Penyimpanan sementara",
    "teachingStyle": "Gaya kuliah",
    "teachingExpertiseTips": "Silakan masukkan keahlian mengajar guru",
    "fitLevelTips": "Pilih level yang sesuai dengan target audiens",
    "fitBusinessTips": "Pilih lini bisnis yang sesuai",
    "chargeInfoTips": "Harap masukkan standar pengisian",
    "teachingStyleTips": "Silakan masukkan gaya ceramah guru",
    "otherInfo": "Informasi lainnya",
    "recommendUnit": "Direkomendasikan oleh",
    "otherOption": "Masalah lain",
    "otherOptionTips": "Harap masukkan hal lain yang perlu ditambahkan",
    "isRequired": "Item ini wajib diisi",
    "pauseSuccess": "Berhasil disimpan",
    "phoneWrong": "silahkan masukkan nomor telepon yang benar",
    "junior": "Anak smp",
    "highSchool": "Siswa SMA",
    "english": "Inggris",
    "mathematics": "matematika",
    "recommendSuccessTips": "Anda berhasil mengirimkan pengajar yang direkomendasikan. Setelah peninjauan selesai, pengajar akan ditambahkan ke kumpulan pengajar",
    "goBackrecommend": "Kembali ke rekomendasi guru",
    "checkTeacherInfo": "Lihat guru",
    "currentState": "Kondisi saat ini",
    "chargeInfo": "Biaya",
    "myCertificate": "Sertifikat saya",
    "learningArchives": "File pembelajaran",
    "allCertificate": "Semua sertifikat",
    "onlineCourse": "Kelas online",
    "faceCourse": "Kelas tatap muka",
    "exams": "pemeriksaan",
    "baseInfo": "informasi dasar",
    "userName": "nama pengguna",
    "name": "Nama",
    "company": "Unit saat ini",
    "learningExperience": "Pelajari sejarah",
    "assessmentIndex": "Indeks penilaian",
    "assessmentStatus": "Status penilaian",
    "assessmentTime": "waktu ujian",
    "onlineLearning": "Pembelajaran online",
    "year": "tahun",
    "faceOutProduceHours": "Instruksi tatap muka (jam kelas)",
    "notFaceOutProduceHours": "Pengajaran tatap muka non-penuh waktu (jam pelajaran)",
    "onlineCenterLearnHours": "Pembelajaran intensif online (jam kelas)",
    "onlineSelfLearnHours": "Belajar mandiri online (jam pelajaran)",
    "outCompanyLearnHours": "Belajar di luar negeri (jam kelas)",
    "allHours": "total periode",
    "onlineSelfLearn": "Pembelajaran online otonom",
    "onlineCentralizedLearning": "Pembelajaran intensif online",
    "outCompanyLearn": "Studi unit asing",
    "faceTrain": "Pelatihan tatap muka",
    "myNotice": "Pesanku",
    "noticeSearchTips": "Telusuri berita yang Anda minati",
    "systemNotice": "Pengingat sistem",
    "message": "Surat pribadi"
  },
  "questionnaire": {
    "notParticipat": "Tidak terlibat",
    "description": "Deskripsi kuesioner",
    "save": "menyimpan",
    "export": "Ekspor",
    "printing": "mencetak",
    "handed": "melaksanakan tugas",
    "topics": "tema",
    "examList": "Daftar pertanyaan tes",
    "tableQuestions": "Pertanyaan tabel",
    "newLine": "Menambahkan baris",
    "deleteLine": "Hapus baris",
    "sort": "Nomor seri",
    "content": "kandungan",
    "shortQuestion": "Jawaban singkat",
    "inputContent": "Harap masukkan konten jawaban",
    "multiple": "Pilihan ganda",
    "single": "Pilihan ganda",
    "saveSuccess": "Berhasil disimpan",
    "submitSuccess": "Berhasil dikirim",
    "submitTips": "Anda telah berhasil mengirimkan kuesioner, terima kasih atas partisipasinya",
    "closePage": "Tutup halaman ini"
  },
  "play": {
    "endStudy": "Akhir studi",
    "tips": "Tips",
    "playTips": "Pengingat: Untuk memastikan bahwa waktu belajar Anda dicatat secara normal oleh sistem, silakan klik tombol \"Akhiri Studi\" di pojok kanan atas untuk keluar dari studi. Jika Anda langsung menutup browser, waktu studi Anda mungkin tidak dicatat secara normal.",
    "notShowAgain": "Jangan meminta pesan ini lagi",
    "gotIt": "Saya mendapatkannya",
    "chapter": "bab",
    "chapterText1": "Pertama",
    "chapterText2": "bab",
    "note": "catatan",
    "noteBlockTitle": "catatan",
    "evaluate": "Evaluasi",
    "evaluateStar": "bintang",
    "saveEvaluate": "Kirimkan",
    "notePlaceholder": "Harap masukkan catatan",
    "closeTips": "Sistem mungkin tidak menyimpan perubahan Anda",
    "closeButton": "pergi",
    "autoStop": "Berhenti bermain secara otomatis",
    "autoStopTips": "Karena Anda sudah lama tidak mengoperasikannya, sistem secara otomatis menghentikan pemutaran video",
    "confirmOut": "Apakah Anda yakin untuk berhenti bermain?",
    "closeOrNot": "Apakah akan menutup jendela saat ini",
    "noCoursePlay": "Tidak ada courseware yang dapat dimainkan dalam kursus ini",
    "attention": "Tolong dicatat!"
  }
};